import React from "react";
import { Button, Tag, Space, Typography, Badge, Tooltip } from "antd";
import PersonChip from "./PersonChip";
import {
  EnvironmentOutlined,
  CalendarOutlined,
  BookOutlined,
  TagsOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

export const CASE_HEADER_HEIGHT = 56;

const CaseHeader = ({
  selectedCase,
  annotationCount = 0,
  onOpenAnnotations,
  onOpenClinical,
}) => {
  const navigate = useNavigate();

  const courseLabel = selectedCase
    ? selectedCase.courseName || selectedCase.course
    : null;

  return (
    <div
      style={{
        height: CASE_HEADER_HEIGHT,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        gap: 16,
        padding: "0 16px",
        borderBottom: "1px solid var(--color-border)",
        background: "var(--color-bg)",
        color: "var(--color-text)",
      }}
    >
      {selectedCase ? (
        <>
          <Text
            strong
            style={{
              fontSize: 16,
              flexShrink: 1,
              minWidth: 0,
              maxWidth: "35%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={selectedCase.pathology}
          >
            {selectedCase.pathology}
          </Text>

          <Space size={[4, 4]} style={{ flexShrink: 0 }}>
            {selectedCase.region && (
              <Tag icon={<EnvironmentOutlined />} style={{ marginRight: 0 }}>
                {selectedCase.region}
              </Tag>
            )}
          </Space>

          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 12,
              minWidth: 0,
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {onOpenClinical && (
              <Tooltip title="Informations cliniques du cas">
                <Button
                  size="small"
                  icon={<ProfileOutlined />}
                  onClick={onOpenClinical}
                >
                  Clinique
                </Button>
              </Tooltip>
            )}
            {onOpenAnnotations && (
              <Tooltip title="Voir toutes les annotations">
                <Badge count={annotationCount} size="small" offset={[-4, 4]}>
                  <Button
                    size="small"
                    icon={<TagsOutlined />}
                    onClick={onOpenAnnotations}
                  >
                    Annotations
                  </Button>
                </Badge>
              </Tooltip>
            )}
            {courseLabel && (
              <Button
                type="link"
                size="small"
                icon={<BookOutlined />}
                style={{ padding: 0 }}
                onClick={() => navigate(`/cours/${selectedCase.course}`)}
              >
                {courseLabel}
              </Button>
            )}
            {selectedCase.date && (
              <Space size={4}>
                <CalendarOutlined style={{ color: "var(--color-text-secondary)" }} />
                <Text type="secondary">{selectedCase.date}</Text>
              </Space>
            )}
            {selectedCase.owner && (
              <PersonChip name={selectedCase.owner} />
            )}
          </div>
        </>
      ) : (
        <Text strong style={{ fontSize: 16 }}>
          Visualisation du cas
        </Text>
      )}
    </div>
  );
};

export default CaseHeader;
